<div>{{ time$ | async }}</div>
